export enum ObjectProtectionState {
  NOT_LOCKED = 'NOT_LOCKED',
  LOCKED_BUT_VISIBLE_FOR_YOU = 'LOCKED_BUT_VISIBLE_FOR_YOU',
  LOCKED = 'LOCKED',
}
